// Compass kill-switch. Flip to false to hide the Compass tab everywhere
// without touching the Portal.js seam. Role gating still applies at the seam:
// the full gate is COMPASS_ENABLED && (user.role==="master" || isAdvisor).
export const COMPASS_ENABLED = true;

// ============================================================================
// TEMPORARY — PILOT 0 CONFIGURATION. REMOVE WHEN PILOT 0 ENDS.
//
// Everything below this line is scaffolding for a single-operator, single-
// subject pilot. It narrows Compass to one operator working on one subject,
// so no other account and no other client can reach the surface while the
// pilot runs. It is not a permanent part of the module's design and should
// be deleted whole — constants, function, and this header — when Pilot 0 is
// over, along with its call sites at the Portal seams.
//
// NOT A SECURITY BOUNDARY. These are compile-time constants inlined into the
// shipped JavaScript bundle. They are readable and editable by anyone with
// the bundle, and a tampered or stale client can ignore them entirely. The
// true authorization boundary is RLS on the intel schema — see the policy
// notes in ./persistence.js, where created_by defaults to auth.uid() and is
// enforced by the sessions_insert and units_insert policies. This gate is a
// blast-radius limiter for the pilot, nothing more.
// ============================================================================

// The pilot operator's public.users.id. In this schema public.users.id IS the
// auth user id — users rows are keyed by auth.uid() rather than carrying a
// separate auth_id column — so this value equals auth.uid() for that account.
// It is the same UUID the database already treats as the master identity in
// the RLS policies captured in
// supabase/migrations/20260523000000_capture_live_db_state.sql.
export const PILOT_0_MASTER_ID = '303a43a6-0768-409d-88f7-bb74710aab0d';

// The canonical TriStarr Talent public.clients.id — the primary key of the
// clients row, which is what flows to Compass as subjectId and what the intel
// tables reference as subject_id.
export const PILOT_0_SUBJECT_ID = 'e9cb46d2-3d28-47a9-9b05-fb51287cce00';

// True only for the one operator/subject pair above. Fails closed: any other
// value — including undefined, null, or a partial match — yields false. The
// comparison is positive strict equality on both arguments, with no trimming,
// lowercasing, or other normalization, so an id that differs by whitespace or
// case is a different id and does not pass.
//
// operatorId MUST be Portal's advisorId prop, NOT user.id. In preview mode the
// user object is replaced wholesale with {...viewingClient.user, role:"client"}
// at src/App.js:928 and src/App.js:966, which overrides id with the CLIENT's
// users.id. advisorId is passed from the outer, unshimmed user at
// src/App.js:931 and :969 and therefore still holds the real operator's id.
export function isPilot0Context(operatorId, subjectId) {
  return operatorId === PILOT_0_MASTER_ID && subjectId === PILOT_0_SUBJECT_ID;
}
